export default "__VITE_ASSET__b6274bdf__"